// frontend/config/brand.ts

export type BrandId = 'trafficcreator' | 'metadeck';

// Enable switching brands via VITE_ACTIVE_BRAND at build time
export const activeBrand: BrandId = (import.meta.env.VITE_ACTIVE_BRAND as BrandId) || 'trafficcreator';

export interface BrandConfig {
  id: BrandId;
  name: string;
  shortName: string;
  subtitle: string;
  logoLetter: string;
  primaryColor: string;
  primaryHover: string;
  supportEmail: string;
  supportWhatsAppNumber: string;
  supportWhatsAppMessage: string;
  apiUrl: string;
}

const resolveApiUrl = (localFallback: string): string => {
  const envUrl = (import.meta.env.VITE_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isLocalhost = host === 'localhost' || host === '127.0.0.1';
    if (!isLocalhost) {
      return window.location.origin;
    }
  }

  return localFallback;
};

const configs: Record<BrandId, BrandConfig> = {
  trafficcreator: {
    id: 'trafficcreator',
    name: 'TRAFFICGEN PRO',
    shortName: 'TRAFFIC',
    subtitle: 'Bot OS',
    logoLetter: 'T',
    primaryColor: '#ff5a0a', // Signature Orange
    primaryHover: '#e94a00',
    supportEmail: 'support@traffic-creator.com',
    supportWhatsAppNumber: import.meta.env.VITE_PUBLIC_WHATSAPP_NUMBER || '61489996250',
    supportWhatsAppMessage: 'Hi Traffic Creator! I have a question and would like support.',
    apiUrl: resolveApiUrl('http://localhost:8000')
  },
  metadeck: {
    id: 'metadeck',
    name: 'Metadeck',
    shortName: 'Metadeck',
    subtitle: '',
    logoLetter: 'M',
    primaryColor: '#ff5a0a',
    primaryHover: '#E64400',
    supportEmail: 'support@metadeck.space',
    supportWhatsAppNumber: import.meta.env.VITE_PUBLIC_WHATSAPP_NUMBER || '61489996250',
    supportWhatsAppMessage: 'Hi Metadeck! I have a question and would like support.',
    apiUrl: resolveApiUrl('https://metadeck.space')
  }
};

export const brandConfig = configs[activeBrand];
